import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { routePagesList } from "../../lib/routePages";
import { DestinationDialog, trackDest } from "./DestinationDialog";

const byName = (a, b) => a.localeCompare(b, "es", { sensitivity: "base" });
const fallback = () => [...new Set(routePagesList().flatMap((p) => [p.origin, p.destination]))].sort(byName);

const Row = ({ items, onPick, copy, promo }) => (
  <div className="flex shrink-0 items-center" aria-hidden={copy || undefined}>
    {items.map((c) => (
      <span key={c} className="flex items-center gap-8 px-6">
        <button type="button" tabIndex={copy ? -1 : 0} data-testid={copy ? undefined : `marquee-dest-${c}`} onClick={() => onPick(c)} className="flex items-center gap-3 font-display text-2xl text-white transition-colors hover:text-[var(--lime)] focus-visible:text-[var(--lime)] focus-visible:outline-none md:text-4xl">
          {c}
          {promo[c] && <span data-testid={copy ? undefined : `marquee-promo-${c}`} className="rounded-full bg-[var(--lime)] px-2.5 py-1 font-sans text-xs font-bold not-italic tracking-wide text-[var(--ink)]">PROMO -{promo[c]}%</span>}
        </button>
        <span className="inline-block h-3 w-3 rounded-full bg-[var(--lime)]" />
      </span>
    ))}
  </div>
);

/** Faja con todos los destinos en orden alfabético. */
export const Marquee = () => {
  const [items, setItems] = useState(fallback);
  const [city, setCity] = useState(null);
  const [promos, setPromos] = useState([]);
  useEffect(() => { api.get("/fare-promos/active").then((r) => setPromos(Array.isArray(r.data) ? r.data : [])).catch(() => setPromos([])); }, []);
  const pick = (c) => { setCity(c); trackDest("open", c); };
  const promo = promos.reduce((m, p) => ({ ...m, [p.destination]: Math.max(m[p.destination] || 0, p.discount_pct) }), {});
  useEffect(() => {
    api.get("/cities").then((r) => { const c = Array.isArray(r.data?.cities) ? r.data.cities : []; if (c.length) setItems([...new Set(c)].sort(byName)); }).catch(() => {});
  }, []);
  return (
    <section data-testid="departures-marquee" aria-label={`Destinos: ${items.join(", ")}`} className="relative overflow-hidden border-y border-white/10 bg-[var(--ink)] py-6 md:py-8">
      <div className="flex w-max animate-marquee hover:[animation-play-state:paused]" style={{ animationDuration: `${Math.max(70, items.length * 4)}s` }}>
        <Row items={items} onPick={pick} promo={promo} />
        <Row items={items} onPick={pick} promo={promo} copy />
      </div>
      <DestinationDialog city={city} onClose={() => setCity(null)} promos={promos} />
    </section>
  );
};
